export function LoadingScreen() { return <div className="loading" role="status"><span className="loading__mark">BV</span><div className="loading__line" /><p>Surveying the route…</p></div> }
